import { DirectionType as SomDirectionType } from '~api/som';

import { ArrowRight16, Return16 } from '@ingrid/iconography/react';
import { ListLayout, Tooltip } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';
import { ComponentAsType } from '~src/types/ComponentAsType';

export function DirectionTypeIcon({
  direction,
  withTooltip = false,
}: {
  direction: SomDirectionType;
  withTooltip?: boolean;
}) {
  const { t } = useTranslation();

  const icon = direction === 'OUTBOUND' ? <ArrowRight16 /> : direction === 'RETURN' ? <Return16 /> : false;
  const content = direction === 'OUTBOUND' ? t('common.outbound') : direction === 'RETURN' ? t('common.return') : false;

  if (withTooltip && content) {
    return (
      <Tooltip content={content}>
        {/* The span (or any non-fragment element) is needed for the tooltip to render */}
        <span>{icon}</span>
      </Tooltip>
    );
  }

  return icon;
}

export function DirectionType({ direction, as }: { direction: SomDirectionType; as?: ComponentAsType }) {
  const { t } = useTranslation();

  return (
    <ListLayout.PrimaryText style={{ alignItems: 'center', display: 'flex', gap: '6px' }} as={as}>
      <DirectionTypeIcon direction={direction} />
      <span>{t(`shipments.list.directionType.${direction}`)}</span>
    </ListLayout.PrimaryText>
  );
}
